import { render, staticRenderFns } from "./PxAutocompleteRoles.vue?vue&type=template&id=1cb8e2e3"
import script from "./PxAutocompleteRoles.vue?vue&type=script&lang=js"
export * from "./PxAutocompleteRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports